<template>
  <PremiumModalForm
    v-if="value"
    :value="value"
    @input="$emit('input', $event)"
    :title="title || 'Image Preview'"
    max-width="900"
    :showFooter="false"
    :persistent="false"
  >
    <div class="premium-image-viewer">
      <img :src="imageSrc" alt="Preview" class="lightbox-img" />
    </div>
  </PremiumModalForm>
</template>

<script>
import PremiumModalForm from './PremiumModalForm.vue';

export default {
  name: 'PremiumImageLightbox',
  components: { PremiumModalForm },
  props: {
    value: { type: Boolean, default: false },
    imageSrc: { type: String, required: true },
    title: { type: String, default: '' }
  }
};
</script>

<style scoped>
.premium-image-viewer {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--border-color, rgba(0,0,0,0.08));
}

.is-dark .premium-image-viewer {
  background: #0f172a;
  border-color: rgba(255,255,255,0.1);
}

.lightbox-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
  display: block;
}

/* Ensure the modal content is centered and takes appropriate space */
:deep(.ism-pmf-body) {
  padding: 12px !important;
}
</style>
